import axios from "axios";
import { loadConfig, getToken } from "../utility";

let config = await loadConfig();

export default function OffPlusController() {
	const token = getToken();

	//> getActiveStates
	this.getActiveStates = async function (showAll) {
		let result = {
			isSuccess: true,
			message: "Success",
			value: [
				{
					stateId: "",
					name: "",
					fullName: "",
					imageUrl: "",
				},
			],
		};
		try {
			const response = await axios.request({
				method: "get",
				maxBodyLength: Infinity,
				url: `${config.apiBaseUrl}OffPlus/GetActiveStates?showAll=${showAll}`,
				headers: {
					accept: "application/json",
					"Content-Type": "application/json",
				},
				data: null,
			});
			result.value = response.data;
		} catch (error) {
			result.isSuccess = false;
			result.message = error.toString();
			if (error.response && error.response.status === 400)
				result.message = error.response.data;
		}
		return result;
	};

	//> getActiveCities
	this.getActiveCities = async function (stateId, showAll) {
		let result = {
			isSuccess: true,
			message: "Success",
			value: [
				{
					cityId: "",
					stateId: "",
					name: "",
					fullName: "",
					imageUrl: "",
				},
			],
		};
		try {
			const response = await axios.request({
				method: "get",
				maxBodyLength: Infinity,
				url: `${config.apiBaseUrl}OffPlus/GetActiveCities?stateId=${stateId}&showAll=${showAll}`,
				headers: {
					accept: "application/json",
					"Content-Type": "application/json",
				},
				data: null,
			});
			result.value = response.data;
		} catch (error) {
			result.isSuccess = false;
			result.message = error.toString();
			if (error.response && error.response.status === 400)
				result.message = error.response.data;
		}
		return result;
	};

	//> getActiveStores
	this.getActiveStores = async function (cityId) {
		let result = {
			isSuccess: true,
			message: "Success",
			value: [
				{
					storeId: "",
					name: "",
					imageUrl: "",
				},
			],
		};
		try {
			const response = await axios.request({
				method: "get",
				maxBodyLength: Infinity,
				url: `${config.apiBaseUrl}OffPlus/GetActiveStores?cityId=${cityId}`,
				headers: {
					accept: "application/json",
					"Content-Type": "application/json",
				},
				data: null,
			});
			result.value = response.data;
		} catch (error) {
			result.isSuccess = false;
			result.message = error.toString();
			if (error.response && error.response.status === 400)
				result.message = error.response.data;
		}
		return result;
	};

	//> getActiveProductModels
	this.getActiveProductModels = async function (storeId) {
		let result = {
			isSuccess: true,
			message: "Success",
			value: [
				{
					productModelId: "",
					productId: "",
					productName: "",
					modelName: "",
					unitCost: "",
					offPercent: "",
					maxOffPercent: "",
					imageUrl: "",
				},
			],
		};
		try {
			const response = await axios.request({
				method: "get",
				maxBodyLength: Infinity,
				url: `${config.apiBaseUrl}OffPlus/GetActiveProductModels?storeId=${storeId}`,
				headers: {
					accept: "application/json",
					"Content-Type": "application/json",
					Authorization: `Bearer ${token}`,
				},
				data: null,
			});
			result.value = response.data;
		} catch (error) {
			result.isSuccess = false;
			result.message = error.toString();
			if (error.response && error.response.status === 400)
				result.message = error.response.data;
		}
		return result;
	};

	//> getActiveProductModel
	this.getActiveProductModel = async function (productModelId) {
		let result = {
			isSuccess: true,
			message: "Success",
			value: {
				productModelId: "",
				productId: "",
				productName: "",
				modelName: "",
				unitCost: "",
				offPercent: "",
				maxOffPercent: "",
				imageUrl: "",
			},
		};
		try {
			const response = await axios.request({
				method: "get",
				maxBodyLength: Infinity,
				url: `${config.apiBaseUrl}OffPlus/GetActiveProductModel?productModelId=${productModelId}`,
				headers: {
					accept: "application/json",
					"Content-Type": "application/json",
					Authorization: `Bearer ${token}`,
				},
				data: null,
			});
			result.value = response.data;
		} catch (error) {
			result.isSuccess = false;
			result.message = error.toString();
			if (error.response && error.response.status === 400)
				result.message = error.response.data;
		}
		return result;
	};

	//> createOrder
	this.createOrder = async function (productModelId, quantity) {
		let result = { isSuccess: true, message: "Success", value: null };
		const token = getToken();
		try {
			const response = await axios.request({
				method: "post",
				maxBodyLength: Infinity,
				url: `${config.apiBaseUrl}OffPlus/CreateAppOrder`,
				headers: {
					accept: "application/json",
					"Content-Type": "application/json",
					Authorization: `Bearer ${token}`,
				},
				data: JSON.stringify({
					productModelId: productModelId,
					quantity: quantity,
					returnUrl: window.location.origin + "/#call-back",
					notes: "پرداخت بلیت اماکن ورزشی - تفریحی",
				}),
			});
			result.value = response.data;
		} catch (error) {
			result.isSuccess = false;
			result.message = error.toString();
			if (error.response && error.response.status === 400)
				result.message = error.response.data;
		}
		return result;
	};

	//> getBanners
	this.getBanners = async function () {
		let result = { isSuccess: true, message: "Success", value: null };
		try {
			const response = await axios.request({
				method: "get",
				maxBodyLength: Infinity,
				url: `${config.apiBaseUrl}OffPlus/GetBanners`,
				headers: {
					accept: "application/json",
					"Content-Type": "application/json",
				},
				data: null,
			});
			result.value = response.data;
		} catch (error) {
			result.isSuccess = false;
			result.message = error.toString();
			if (error.response && error.response.status === 400)
				result.message = error.response.data;
		}
		return result;
	};

	//> getRemoteCategories
	this.getRemoteCategories = async function () {
		let result = { isSuccess: true, message: "Success", value: null };
		try {
			const response = await axios.request({
				method: "get",
				maxBodyLength: Infinity,
				url: `${config.apiBaseUrl}OffPlus/GetRemoteCategories`,
				headers: {
					accept: "application/json",
					"Content-Type": "application/json",
				},
				data: null,
			});
			result.value = response.data;
		} catch (error) {
			result.isSuccess = false;
			result.message = error.toString();
			if (error.response && error.response.status === 400)
				result.message = error.response.data;
		}
		return result;
	};

	//> getRemoteStores
	this.getRemoteStores = async function (category) {
		let result = { isSuccess: true, message: "Success", value: null };
		try {
			const response = await axios.request({
				method: "get",
				maxBodyLength: Infinity,
				url: `${config.apiBaseUrl}OffPlus/GetRemoteStores?category=${category}`,
				headers: {
					accept: "application/json",
					"Content-Type": "application/json",
				},
				data: null,
			});
			result.value = response.data;
		} catch (error) {
			result.isSuccess = false;
			result.message = error.toString();
			if (error.response && error.response.status === 400)
				result.message = error.response.data;
		}
		return result;
	};

	//> getRemoteStore
	this.getRemoteStore = async function (code) {
		let result = { isSuccess: true, message: "Success", value: null };
		try {
			const response = await axios.request({
				method: "get",
				maxBodyLength: Infinity,
				url: `${config.apiBaseUrl}OffPlus/GetRemoteStore?code=${code}`,
				headers: {
					accept: "application/json",
					"Content-Type": "application/json",
				},
				data: null,
			});
			result.value = response.data;
		} catch (error) {
			result.isSuccess = false;
			result.message = error.toString();
			if (error.response && error.response.status === 400)
				result.message = error.response.data;
		}
		return result;
	};
	//>
}
